export const LOGOUT = 'LOGOUT';

export const AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS';
export const AUTHORIZATION_FAIL = 'AUTHORIZATION_FAIL';

export const SERVER_ERROR_MESSAGE = 'Щось пішло не так';
export const UNAUTHORIZED_MESSAGE = 'Логін чи пароль не вірний';
